<template>
  <div id="camera2" @click="cameraOn">
    <span v-if="!active">タッチしてカメラを起動してください</span>
    <div id="camera-area" class="camera-area">
      <canvas v-if="active" class="detect-area"></canvas>
    </div>
  </div>
</template>

<script>
import { ref, defineComponent, watch, onUnmounted } from 'vue'
import Quagga from 'quagga'

export default defineComponent({
  setup (_, context) {
    const active = ref(false)
    const detectedCount = ref(0)
    const detectedCode = ref('')
    const barcodeInput = ref(true)

    onUnmounted(() => {
      try {
        offQuagga()
        Quagga.stop()
      } catch (error) {
        console.log(error)
      }
    })

    const cameraOn = () => {
      console.log('base')
      console.log(Quagga)
      active.value = !active.value
    }

    /**
    * Quaggaの初期化処理
    */
    const initQuagga = () => {
      // バーコード検出時の処理を設定
      Quagga.onDetected(onDetected)

      // Quaggaの設定項目
      const config = {
        // frequency: 5,
        // カメラの映像の設定
        inputStream: {
          type: 'LiveStream',
          // カメラ映像を表示するHTML要素の設定
          target: document.querySelector('#camera-area'),
          // バックカメラの利用を設定. (フロントカメラは"user")
          constraints: {
            facingMode: 'environment',
            width: 480,
            height: 640
          },
          // 検出範囲の指定: 上下30%は対象外
          area: { top: '40%', right: '10%', left: '10%', bottom: '40%' }
        },
        // 解析するワーカ数の設定
        numOfWorkers: navigator.hardwareConcurrency || 4,
        // バーコードの種類を設定: ISBNは"ean_reader"
        decoder: { readers: ['ean_reader', 'ean_8_reader', 'code_39_reader', 'code_128_reader'] }
      }
      // 初期化の開始。合わせて、初期化後の処理を設定
      Quagga.init(config, onInitilize)
    }

    const offQuagga = () => {
      Quagga.offDetected(onDetected)
    }

    /**
    * Quaggaの初期化完了後の処理
    * errorがなければ、起動する
    */
    const onInitilize = (error) => {
      if (error) {
        // エラーがある場合は、キャンセルをEmitする
        console.error(`Error: ${error}`, error)
        alert(error)
        // onClickCancel()
        return
      }

      // エラーがない場合は、読み取りを開始
      console.info('Initialization finished. Ready to start')
      Quagga.start()
        .then(() => {
          // const imageCapture = new ImageCapture(Quagga.CameraAccess.getActiveTrack())
          // imageCapture.setOptions({ fillLightMode: 'torch' })
        })
    }

    /*
    * バーコード検出時の処理
    */
    const onDetected = (success) => {
      // ISBNは'success.codeResult.code'から取得
      console.log('play')
      const isbn = success.codeResult.code
      if (barcodeInput.value) {
        // 読み取り誤差が多いため、3回連続で同じ値だった場合に成功とする
        if (detectedCode.value === isbn) {
          detectedCount.value++
        } else {
          detectedCount.value = 0
          detectedCode.value = isbn
        }
        if (detectedCount.value === 5 && barcodeInput.value) {
          barcodeInput.value = false
          setTimeout(() => {
            barcodeInput.value = true
            detectedCode.value = ''
            detectedCount.value = 0
          }, 3000)
          context.emit('inputedBarcode', { value: detectedCode.value })
          detectedCode.value = ''
        }
      }
    }

    // ****************************************************
    // * watch
    // ****************************************************
    /**
    * this.activeを監視してQuaggaの開始/停止をする
    */
    watch(active, () => {
      if (active.value) {
        // モーダル表示時、Quaggaを起動
        console.log('on')
        initQuagga()
      } else {
        console.log('off')
        offQuagga()
        // モーダル非表示時、Quaggaを停止
        if (Quagga) Quagga.stop()
      }
    })

    return {
      cameraOn,
      active
    }
  }
})
</script>
<style>
.camera-area {
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: absolute;
}
.detect-area {
  top: 50%;
  height: 0px;
  width: 60%;
  left: 20%;
  border: 4px solid red;
  position: absolute;
  z-index: 1;
  transform: translateZ(1px);
}
.camera-area video {
  width: 100%;
  height: 100%;
  z-index: -1;
}
.camera-area canvas.drawingBuffer {
  width: 100%;
  height: 100%;
  z-index: -1;
}
</style>
<style scoped>
#camera2 {
  position: relative;
  height: 100%;
  width: 100%;
  font-size: medium;
}
#camera span.span-isbn10 {
  position: absolute;
  bottom: auto;
  top: 2vh;
  left: 0;
  right: 0;
  font-size: large;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
  z-index: 10;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: white;
  -webkit-text-fill-color: black;
}

</style>
